import Vue from 'vue'
import accordion from './components/accordion.vue'

Vue.component('accordion', accordion)

if (document.querySelector('#accordions') !== null) {
  new Vue({
    el: '#accordions'
  })
}

if (document.querySelector('#calculator-accordions') !== null) {
  new Vue({
    el: '#calculator-accordions'
  })
}
